import { withTranslation } from '@application/i18n/with_translation';
import { Avatar, Box, Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';

interface Props {
	name?: string | null;
	imageSrc?: string | null;
	title?: string | null;
}

export function ContactItem({ imageSrc, name, title }: Props): JSX.Element {
	return (
		<Box
			as='li'
			gap={tokens.spacing.x1_5}
			direction='row'
			style={{
				minHeight: '40px',
			}}
		>
			<Avatar name={name ?? ''} src={imageSrc} />
			<Flex>
				{name != null ? (
					<>
						<Text variant='labelSemiBold'>{name ?? 'anonym'}</Text> {/* TODO: what to write when depersonalized? */}
						{title != null ? <Text variant='labelSmallRegular'>{title}</Text> : null}
					</>
				) : (
					<Text variant='labelSmallRegular'>{withTranslation('PW.Component.Visits.AppointmentInfo.CallWith.Guest')}</Text>
				)}
			</Flex>
		</Box>
	);
}
